<h2 app-landing-page-title i18n="@@assets.transfer.reminder.header">Transfer Asset Email Templates
</h2>

<app-email-template-parameters [replacementParameters]="replacementParameters">
</app-email-template-parameters>

<mat-card>
  <mat-card-header>
    <mat-card-title i18n="@@assets.transfer.reminder.header">
      Transfer Asset Email Templates
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <h2 i18n="@@assets-transfer-email-templates.subject">Subject</h2>
    <persistent-simple-text-section-entity section="assets.transfer-reminder.title"
      [textTransformer]="textTransformer"></persistent-simple-text-section-entity>
    <br />
    <h2 i18n="@@assets-transfer-email-templates.body">Body</h2>
    <persistent-rich-text-section-entity section="assets.transfer-reminder.body"
      [textTransformer]="textTransformer"></persistent-rich-text-section-entity>
  </mat-card-content>
</mat-card>
